import {
  GET_MATERIALS,
  CREATE_MATERIAL,
  REMOVE_MATERIAL,
  UPDATE_MATERIAL,
} from './types';

export const getMaterials = (companyId) => ({
  type: GET_MATERIALS,
  request: {
    method: 'GET',
    url: `/company/${companyId}/materials`,
  },
  meta: {
    thunk: true,
  },
});

export const createMaterial = (companyId, payload) => ({
  type: CREATE_MATERIAL,
  request: {
    method: 'POST',
    url: `/company/${companyId}/materials`,
    data: payload,
  },
  meta: {
    thunk: true,
  },
});

export const removeMaterial = (companyId, materialId) => ({
  type: REMOVE_MATERIAL,
  materialId,
  request: {
    method: 'DELETE',
    url: `/company/${companyId}/materials/${materialId}`,
  },
  meta: {
    thunk: true,
  },
});

export const updateMaterial = (companyId, materialId, payload) => ({
  type: UPDATE_MATERIAL,
  materialId,
  request: {
    method: 'PATCH',
    url: `/company/${companyId}/materials/${materialId}`,
    data: payload,
  },
  meta: {
    thunk: true,
  },
});
